(function(){
  'use strict';

  var body=document.body;
  if(!body||!body.classList.contains('template-product'))return;

  var root=document.documentElement;
  root.classList.add('r07-pdp-active');
  root.setAttribute('data-fenix-pdp-authority','R07.8.1');

  document.querySelectorAll('.fnx-r07-film,.fnx-r07-rail').forEach(function(node){node.remove();});

  var visualProperties=[
    'background','background-color','background-image',
    'color','border','border-color','border-top','border-right','border-bottom','border-left',
    'border-top-color','border-right-color','border-bottom-color','border-left-color',
    'box-shadow','text-shadow','font-family','filter','animation','transition'
  ];

  function normalizeDescription(){
    var description=document.querySelector('.nmps__story-content');
    if(!description)return;
    description.querySelectorAll('style,link[rel="stylesheet"]').forEach(function(element){element.remove();});
    var documentRoot=description.firstElementChild;
    if(documentRoot){
      documentRoot.classList.add('r07-pdp-document');
      documentRoot.classList.remove('r07-pdp-pill','r07-pdp-accent','r07-pdp-surface','r07-pdp-cta');
    }

    description.querySelectorAll('[style]').forEach(function(element){
      var raw=(element.getAttribute('style')||'').toLowerCase();
      var text=(element.textContent||'').trim();
      var ownText=[].slice.call(element.childNodes).filter(function(node){return node.nodeType===3;}).map(function(node){return node.textContent||'';}).join(' ').trim();
      element.classList.remove('r07-pdp-pill','r07-pdp-accent','r07-pdp-surface','r07-pdp-cta');
      if(/display\s*:\s*inline-block/.test(raw))element.classList.add('r07-pdp-pill');
      if(/(^|;)\s*color\s*:/.test(raw)&&element.children.length===0&&text.length<80&&/#1ee6c1|#12d8b0|#39f3d2|0\s*,\s*255\s*,\s*204|30\s*,\s*230\s*,\s*193/.test(raw)){
        element.classList.add('r07-pdp-accent');
      }
      if(/background/.test(raw)&&element!==documentRoot&&element.parentElement!==documentRoot){
        var childSurfaces=element.querySelectorAll('[style*="background"]').length;
        if(childSurfaces<2||ownText.length<220)element.classList.add('r07-pdp-surface');
      }
      if(/añadir al carrito|agregar al carrito/i.test(text)&&text.length<190&&/background/.test(raw)){
        element.classList.add('r07-pdp-cta');
      }
      visualProperties.forEach(function(property){element.style.removeProperty(property);});
    });

    description.querySelectorAll('.fnx-section').forEach(function(section,index){
      section.classList.add('r07-pdp-section');
      section.style.setProperty('--r07-section-index',String(index));
    });
  }

  var icons={
    brain:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8.3 4.2A3.7 3.7 0 0 0 5 9.7a3.9 3.9 0 0 0 .8 7.6A3.4 3.4 0 0 0 12 19.2V6.1a3.1 3.1 0 0 0-3.7-1.9Z"/><path d="M15.7 4.2A3.7 3.7 0 0 1 19 9.7a3.9 3.9 0 0 1-.8 7.6A3.4 3.4 0 0 1 12 19.2V6.1a3.1 3.1 0 0 1 3.7-1.9Z"/><path d="M7.5 9.4c1.5.1 2.6 1.1 2.8 2.6M16.5 9.4c-1.5.1-2.6 1.1-2.8 2.6"/></svg>',
    mood:'<svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="8.5"/><path d="M8.5 10h.01M15.5 10h.01M8.6 14.2c2 1.8 4.8 1.8 6.8 0"/></svg>',
    dna:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M7 3c0 7 10 11 10 18M17 3C17 10 7 14 7 21M8.3 6h7.4M7.5 10h9M7.5 14h9M8.3 18h7.4"/></svg>',
    capsule:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m8.2 17.8-2-2a4.1 4.1 0 0 1 0-5.8L10 6.2a4.1 4.1 0 0 1 5.8 0l2 2a4.1 4.1 0 0 1 0 5.8L14 17.8a4.1 4.1 0 0 1-5.8 0Z"/><path d="m8.2 8 7.8 7.8"/></svg>',
    truck:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M3 6h11v10H3zM14 10h4l3 3v3h-7z"/><circle cx="7" cy="18" r="1.5"/><circle cx="18" cy="18" r="1.5"/></svg>',
    lock:'<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="10" width="14" height="10" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3M12 14v2"/></svg>',
    chat:'<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 18.5 3.5 21l4-1.2A9 9 0 1 0 5 18.5Z"/><path d="M8 11.5h.01M12 11.5h.01M16 11.5h.01"/></svg>'
  };

  function setIcon(element,name){
    if(!element||!icons[name])return;
    element.innerHTML=icons[name];
    element.classList.add('r07-pdp-vector-icon');
  }

  function normalizeIcons(){
    var benefitIcons=document.querySelectorAll('.nmps__benefit-icon');
    var order=['brain','mood','dna','capsule'];
    benefitIcons.forEach(function(element,index){
      if(element.querySelector('svg')){
        element.classList.add('r07-pdp-vector-icon');
        return;
      }
      var text=(element.textContent||'').trim();
      var name=text.indexOf('🧠')>-1?'brain':text.indexOf('😊')>-1?'mood':text.indexOf('🧬')>-1?'dna':text.indexOf('💊')>-1?'capsule':order[index%order.length];
      setIcon(element,name);
    });

    var trustIcons=document.querySelectorAll('.nm-trust-bar__icon');
    ['truck','lock','chat'].forEach(function(name,index){setIcon(trustIcons[index],name);});
    setIcon(document.getElementById('nmChatFab'),'brain');

    document.querySelectorAll('.nmps__story-content div').forEach(function(element){
      if(element.children.length)return;
      var text=(element.textContent||'').trim();
      var name=text==='🧠'?'brain':text==='😊'?'mood':text==='🧬'?'dna':text==='💊'?'capsule':'';
      if(name)setIcon(element,name);
    });
  }

  function normalizeQuickCards(){
    var system=document.querySelector('.nmps');
    if(!system)return;
    system.querySelectorAll('.nmps__essential-wrap').forEach(function(element,index){
      if(index>0)element.remove();
    });

    var quick=system.querySelector('[data-nm-quick-cards]');
    if(!quick)return;
    var productId=system.getAttribute('data-nm-product-id')||'';
    if(productId==='6772127662147'&&quick.querySelector('.nmps__benefit--fallback')){
      quick.querySelectorAll('.nmps__benefit:not(.nmps__benefit--fallback)').forEach(function(element){element.remove();});
    }

    var seen={};
    quick.querySelectorAll('.nmps__benefit').forEach(function(card){
      var key=(card.textContent||'').replace(/\s+/g,' ').trim().toLowerCase();
      if(!key)return;
      if(seen[key])card.remove();
      else seen[key]=true;
    });
  }

  function normalizeIntro(){
    var intro=document.querySelector('.nmps__authored-hero');
    if(!intro||intro.hidden||!intro.firstElementChild)return;

    intro.querySelectorAll('[style]').forEach(function(element){
      visualProperties.forEach(function(property){element.style.removeProperty(property);});
    });

    if(intro.dataset.r07IntroReady==='1')return;
    intro.dataset.r07IntroReady='1';
    intro.classList.add('r07-pdp-intro-ready');
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(reduce||!('IntersectionObserver' in window)){
      intro.classList.add('is-r07-intro-visible');
      return;
    }
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting)return;
        intro.classList.add('is-r07-intro-visible');
        observer.disconnect();
      });
    },{rootMargin:'0px 0px -12% 0px',threshold:.16});
    observer.observe(intro);
  }

  function normalizeMotion(){
    var scenes=document.querySelectorAll('.nmps__quick,.nmps__deep');
    scenes.forEach(function(element){
      element.dataset.r07PdpMotionReady='1';
      element.classList.remove('fnx-r07-reveal','is-r07-active','is-r07-shown');
      element.removeAttribute('data-r07-pdp-reveal');
      element.style.removeProperty('transition-delay');
      element.classList.add('is-visible');
    });
  }

  function normalizeControls(){
    var addText=document.getElementById('AddToCartText');
    function normalizeAddText(){
      if(addText&&/empezar ahora/i.test(addText.textContent||''))addText.textContent='Agregar al carrito';
    }
    normalizeAddText();
    if(addText&&addText.dataset.r07TextGuard!=='1'&&'MutationObserver' in window){
      addText.dataset.r07TextGuard='1';
      new MutationObserver(normalizeAddText).observe(addText,{childList:true,characterData:true,subtree:true});
    }
    var productForm=document.getElementById('AddToCartForm');
    if(productForm&&productForm.querySelector('.nm-variant-chips')){
      productForm.classList.add('has-nm-variant-chips');
    }
    document.querySelectorAll('.nmps__oneclick').forEach(function(details){
      var summary=details.querySelector(':scope > summary');
      function sync(){if(summary)summary.setAttribute('aria-expanded',details.open?'true':'false');}
      details.addEventListener('toggle',sync);
      sync();
      if(!summary||summary.dataset.r07InviteReady==='1')return;
      summary.dataset.r07InviteReady='1';
      var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      function invite(){
        if(reduce||details.open)return;
        summary.classList.remove('is-r07-inviting');
        window.requestAnimationFrame(function(){summary.classList.add('is-r07-inviting');});
        window.setTimeout(function(){summary.classList.remove('is-r07-inviting');},1350);
      }
      summary.addEventListener('pointerenter',invite,{passive:true});
      summary.addEventListener('focus',invite,{passive:true});
      if(!reduce&&'IntersectionObserver' in window){
        var inviteObserver=new IntersectionObserver(function(entries){
          if(entries.some(function(entry){return entry.isIntersecting;})){
            invite();
            inviteObserver.disconnect();
          }
        },{threshold:.55});
        inviteObserver.observe(summary);
      }
    });
  }

  function normalizeGallery(){
    var main=document.getElementById('ProductPhotoImg');
    var rail=document.getElementById('ProductThumbs');
    if(!main||!rail||rail.dataset.r07GalleryReady==='1')return;
    rail.dataset.r07GalleryReady='1';

    rail.addEventListener('click',function(event){
      var thumb=event.target.closest('.product-single__thumbnail');
      if(!thumb)return;
      event.preventDefault();
      var source=thumb.getAttribute('data-full')||thumb.getAttribute('href');
      if(!source)return;
      var preview=new Image();
      main.style.opacity='.34';
      preview.onload=function(){
        main.src=source;
        main.srcset=source+' 2048w';
        main.setAttribute('data-zoom',source);
        var thumbImage=thumb.querySelector('img');
        if(thumbImage&&thumbImage.alt)main.alt=thumbImage.alt;
        rail.querySelectorAll('.product-single__thumbnail').forEach(function(node){node.classList.toggle('is-active',node===thumb);});
        main.style.opacity='1';
        thumb.scrollIntoView({block:'nearest',inline:'nearest',behavior:'smooth'});
      };
      preview.onerror=function(){main.style.opacity='1';};
      preview.src=source;
    });
  }

  function init(){
    normalizeDescription();
    normalizeIcons();
    normalizeQuickCards();
    normalizeIntro();
    normalizeMotion();
    normalizeControls();
    normalizeGallery();
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init,{once:true});
  }else{
    init();
  }

  window.setTimeout(init,120);
  window.setTimeout(init,700);

  var productInfo=document.querySelector('.nmps');
  if(productInfo&&'MutationObserver' in window){
    var queued=0;
    var observer=new MutationObserver(function(){
      if(queued)return;
      queued=window.setTimeout(function(){queued=0;init();},24);
    });
    observer.observe(productInfo,{childList:true,subtree:true});
    window.setTimeout(function(){observer.disconnect();},1800);
  }
})();
